var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.__('Export as CSV'),"loading":_vm.isPreparingCsvExport,"icon":_vm.isPreparingCsvExport ? '' : 'export'},on:{"click":_vm.initiateCsvExport}},[_vm._v("\n  "+_vm._s(_vm.__('Export'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }